import React from 'react'
import Identicon from 'react-identicons'
import Link from '../../helper/link'

interface INavigationLink {
    icon?: string | null
    isActive: boolean
    label: string
    url?: string
    route?: string
    parameters?: { [key: string]: string | number | undefined }
    supportsAllServices?: boolean
    setSkipHistoryApi: boolean
    modal?: boolean
    useIdenticon?: boolean
    showTooltip: boolean
}

export class NavigationLink extends React.PureComponent<INavigationLink> {
    public render() {
        const {
            icon,
            isActive,
            label,
            useIdenticon,
            route,
            setSkipHistoryApi,
            parameters,
            supportsAllServices,
            url,
            modal,
            showTooltip,
        } = this.props

        const hasActiveStyle = isActive ? 'sideNav-button--active' : ''
        const cnIcon = `fa ${icon}`
        const cnWrapper = `sideNav-button ${hasActiveStyle} tw-tooltip tw-tooltip--right`

        if (!route && url) {
            return (
                <a
                    href={url}
                    className={cnWrapper}
                    data-tooltip-id="navTooltip"
                    data-tooltip-content={label}
                    data-tooltip-hidden={!showTooltip}
                >
                    <i className={cnIcon} aria-hidden="true"></i>
                    <span className="sideNav-label" title={label}>
                        {label}
                    </span>
                </a>
            )
        }

        if (route)
            return (
                <Link
                    className={cnWrapper}
                    route={route}
                    skipHistoryApi={setSkipHistoryApi}
                    params={parameters}
                    supportsAllServices={supportsAllServices}
                    data-tooltip-id="navTooltip"
                    data-tooltip-content={label}
                    data-tooltip-hidden={!showTooltip}
                    onClick={
                        modal
                            ? ev => {
                                  ev.preventDefault()

                                  const $modal = jQuery('#selector-modal')

                                  let url = ev.target.href

                                  if (url === undefined) {
                                      url = $(ev.target)
                                          .closest('a')
                                          .attr('href')
                                  }

                                  jQuery.ajax({
                                      url,
                                      // @ts-ignore
                                      success: data => $modal.html(data).modal('toggle'),
                                  })
                              }
                            : undefined
                    }
                >
                    {icon ? <i className={cnIcon} aria-hidden="true"></i> : null}
                    {useIdenticon && <Identicon string={label} size="17" fg="white" />}
                    <span className="sideNav-label">{label}</span>
                </Link>
            )

        return null
    }
}

export default NavigationLink
